import React from 'react';

export const DUMPERT_CONTEXT = '__DUMPERT_CONTEXT__';

export const getContextFromWindow = () =>
  typeof window === 'object' && window[DUMPERT_CONTEXT] ? window[DUMPERT_CONTEXT] : {};

export const CommentContext = React.createContext({});
